import { useRouteError } from 'react-router-dom';

/**
 * Route `errorElement` that hands the error to `AppErrorBoundary`.
 *
 * Without it, the data router catches route errors itself and shows its
 * built-in page, so a missing chunk after a deployment never reaches the
 * stale-build recovery.
 */
export function RethrowRouteError(): never {
	throw useRouteError();
}
